<nav class="navbar navbar-expand-md">
    <div class="container-md px-0">
      <a class="navbar-brand d-flex align-items-end pb-0"[href]="getWWWUrl('')">
        <img src="/assets/images/WeShape-logo-dark.png" alt="WeShape Logo"
          class="d-inline-block align-text-top d-flex align-self-end">
      </a>
    </div>
  </nav>